import {
    Component,
    ComponentFactoryResolver,
    OnInit,
    ViewChild,
    ViewContainerRef,
    ViewEncapsulation,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ScriptLoaderService } from '../_services/script-loader.service';
import { AuthenticationService } from './_services/authentication.service';
import { AlertService } from './_services/alert.service';
import { UserService } from './_services/user.service';
import { AlertComponent } from './_directives/alert.component';
import { LoginCustom } from './_helpers/login-custom';
import { Helpers } from '../helpers';
import { ApiService } from '../main/pages/api-service.service';


@Component({
    selector: '',
    templateUrl: './templates/login-1.component.html',
    styleUrls: ['./templates/login-1.component.css'],
    encapsulation: ViewEncapsulation.None,
})

export class AuthComponent implements OnInit {
    model: any = {};
    loading = false;
    error = '';
    returnUrl: '/portfolio';
    nextLibAvailable = false

    @ViewChild('alertSignin',
        { read: ViewContainerRef }) alertSignin: ViewContainerRef;
    @ViewChild('alertSignup',
        { read: ViewContainerRef }) alertSignup: ViewContainerRef;
    @ViewChild('alertForgotPass',
        { read: ViewContainerRef }) alertForgotPass: ViewContainerRef;

    constructor(
        private _router: Router,
        private _script: ScriptLoaderService,
        private _userService: UserService,
        private _route: ActivatedRoute,
        private _authService: AuthenticationService,
        private _alertService: AlertService,
        private cfr: ComponentFactoryResolver,
        private service: ApiService,
    ) {
    }


    ngOnInit() {

        this.model.remember = true;
        this.returnUrl = this._route.snapshot.queryParams['returnUrl'] || '/';
        this._router.navigate([this.returnUrl]);

        this._script.loadScripts('body', [
            'assets/vendors/base/vendors.bundle.js',
            'assets/demo/demo10/base/scripts.bundle.js'], true).then(() => {
                Helpers.setLoading(false);
                LoginCustom.init();
            });
    }

    signin() {
        this.error = '';
        Helpers.setLoading(true);
        this._authService.login(this.model.email, this.model.password).subscribe(
            data => {
                if (data) {
                    localStorage.setItem('currentUser', JSON.stringify(data));
                    this.service.me().subscribe(result => {
                        let res = result
                        if (res['has_changed_password'] == true) {
                            this._router.navigate(['/portfolio']);
                        }
                        else {
                            this._router.navigate(['/changepassword']);
                        }
                        Helpers.setLoading(false);
                    })
                }
            },
            error => {
                this.outsession(error.status);
                this.error = 'Invalid Credentials'
                // this.showAlert('alertSignin');
                // this._alertService.error('Invalid Credentials');
                Helpers.setLoading(false);
            });
    }

    outsession(data) {
        if (data == 0) {
            localStorage.removeItem('currentUser');
            this._router.navigate(['/login'])
        }
    }


    // showAlert(target) {
    //     this[target].clear();
    //     let factory = this.cfr.resolveComponentFactory(AlertComponent);
    //     let ref = this[target].createComponent(factory);
    //     ref.changeDetectorRef.detectChanges();
    // }
}


// WEBPACK FOOTER //
// D:/FMFB/FMFB Dashboard/src/app/auth/auth.component.ts